(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sacred-geometry"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
      },
      { rootMargin: '120px 0px' }
    );

    function observe(scope) {
      (scope || document).querySelectorAll('[data-geometry]').forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        observe();
      });
    } else {
      observe();
    }

    document.addEventListener('shopify:section:load', function (event) {
      observe(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;

    function revealAll(scope) {
      (scope || document).querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animationOff = root.dataset.animation === 'none';
    var observer = null;

    if (!reduceMotion && !animationOff && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    function observe(scope) {
      if (!observer) return revealAll(scope);
      (scope || document).querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
        observer.observe(el);
      });
    }

    function openDialog(id, trigger) {
      var dialog = document.getElementById(id);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      dialog._trigger = trigger;
      dialog.showModal();
      var focusTarget = dialog.querySelector('[autofocus]') || dialog.querySelector('input, a, button');
      if (focusTarget) focusTarget.focus();
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-dialog-open]');
      if (opener) {
        event.preventDefault();
        openDialog(opener.getAttribute('data-dialog-open'), opener);
        return;
      }

      var closer = event.target.closest('[data-dialog-close]');
      if (closer) {
        var parentDialog = closer.closest('dialog');
        if (parentDialog) parentDialog.close();
        return;
      }

      // Close a modal dialog when its backdrop is clicked.
      if (event.target.tagName === 'DIALOG' && event.target.open) {
        var rect = event.target.getBoundingClientRect();
        var inside =
          event.clientX >= rect.left && event.clientX <= rect.right &&
          event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) event.target.close();
      }
    });

    document.addEventListener(
      'close',
      function (event) {
        var dialog = event.target;
        if (dialog.tagName === 'DIALOG' && dialog._trigger) {
          dialog._trigger.focus();
          dialog._trigger = null;
        }
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        observe();
      });
    } else {
      observe();
    }

    // Theme Editor: re-run when sections are added or re-rendered.
    document.addEventListener('shopify:section:load', function (event) {
      observe(event.target);
    });
    document.addEventListener('shopify:block:select', function (event) {
      revealAll(event.target.closest('.shopify-section') || event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
